// extracted by mini-css-extract-plugin
module.exports = {"GlobalHeader":"GlobalHeader___3qU2H"};